import { ConfigurationType } from '@icc/configurator/shared';
import { Injectable } from '@angular/core';
import { EventBusService } from '@icc/shared';
import { ConfiguratorsAvailabilityService } from '@icc/configurator/shared';
import { CurrentConfiguratorService } from '@icc/configurator/shared';

@Injectable({
    providedIn: 'root'
})
export class ConfiguratorCurrentConfiguratorService extends CurrentConfiguratorService {
    conf: ConfigurationType;
    constructor(
        private configuratorsAvailabilityService: ConfiguratorsAvailabilityService,
        private eventBusService: EventBusService
    ) {
        super();

        eventBusService.subscribeWithoutConfiguration<ConfigurationType>('changedConfiguratorLocal', (data) => {
            this.changeConfigurator(data.value)
        })
    }

    changeConfigurator(conf: ConfigurationType) {
        this.conf = conf;
        if (
            this.configuratorsAvailabilityService.availableConfigs[this.conf]
        ) {
            this.eventBusService.post({
                key: 'changedConfigurator',
                value: this.conf,
            });
        }
    }

    setConfigurator(config: ConfigurationType) {
        this.conf = config;
        if (this.configuratorsAvailabilityService.configs.indexOf(this.conf) > -1) {
            this.eventBusService.post({
                key: 'changedConfigurator',
                value: this.conf,
            });
        }
    }
}
